import type { AreaCatalog } from '../area';
import type { contacts as en } from '../en/contacts';

export const contacts = {
  'contacts.add.placeholder': 'Kennung oder name@example.com',
  'contacts.add.label': 'Kontakt über Kennung oder Adresse hinzufügen',
  'contacts.add.send': 'Senden',
  'contacts.add.sent': 'Anfrage an {identifier} gesendet.',
  'contacts.empty':
    'Noch keine Kontakte. Mit einem Kontakt könnt ihr euch gegenseitig einsetzen und Aufgaben teilen.',
  'contacts.requests': 'Anfragen',
  'contacts.groupInvitations': 'Gruppeneinladungen',
  'contacts.contacts': 'Kontakte',
  'contacts.sent': 'Gesendet',
  'contacts.blocked': 'Gesperrt',
  'contacts.accept': 'Annehmen',
  'contacts.decline': 'Ablehnen',
  'contacts.withdrawn': 'zurückgezogen',
  'contacts.addedYou': '{adder} hat dich zu {group} hinzugefügt',
  'contacts.youWereAdded': 'Du wurdest zu {group} hinzugefügt',
  'contacts.until': 'bis {date}',
  'contacts.withdraw': 'Zurückziehen',
  'contacts.unblock': 'Entsperren',
  'contacts.remove': 'Kontakt entfernen',
  'contacts.options': 'Optionen für {name}',
  'contacts.block': 'Sperren',
  'contacts.block.withdrawn': 'Bis du entsperrst, geht keine Anfrage zwischen euch durch.',
  'contacts.block.request':
    'Lehnt diese Anfrage ab. Bis du entsperrst, geht keine Anfrage zwischen euch durch.',
  'contacts.block.invitations':
    'Blendet die Einladungen dieser Person aus. Bis du entsperrst, geht keine Anfrage zwischen euch durch.',
  'contacts.block.contact':
    'Entfernt den Kontakt. Bis du entsperrst, geht keine Anfrage zwischen euch durch.',
  'contacts.reach.empty': 'Eine Kennung oder eine Adresse ist nötig.',
  'contacts.reach.notAddress': 'Das ist keine Adresse.',
  'contacts.reach.notHandle': 'Das ist weder eine Kennung noch eine Adresse.',
} as const satisfies AreaCatalog<typeof en>;
